import api from '@pray/shared/utils/api';

export async function getLeadCampaignCsvExport({ leadCampaignId, leadsFrom = '', leadsTo = '' }) {
  if (!leadCampaignId) throw Error('Campaign ID is required');

  const url = `/web/studio/lead-campaigns/${leadCampaignId}/export/csv`;
  const params = {};
  if (leadsFrom) params.leads_from = leadsFrom;
  if (leadsTo) params.leads_to = leadsTo;
  const response = await api.executeGetRequest(url, params, { responseType: 'blob' });

  return response.data;
}
